//
// Copyright (c) 2020 Astute Global, Inc.
//
// The view for the Site Map editor
//

define(["marionette", "jquery", "./template/siteMapTemplate.html"], function (
  Marionette,
  $,
  SiteMapTemplate,
) {
  "use strict";

  const SiteMapView = {};

  SiteMapView.siteMapView = Marionette.Layout.extend({
    template: SiteMapTemplate,
    events: {
      "change #siteMapCss": function (e) {
        const file = e.target.files[0];
        this.trigger("upload:css", file, e.target.form);
      },
      "change #siteMapLocale": function (e) {
        const value = $(e.target).val();
        this.trigger("change:languageId", +value);
      },
      "change #siteMapPrimaryTouchPoint": function (e) {
        const value = $(e.target).val();
        this.trigger("change:primaryTouchPointId", +value);
      },
      "change #siteMapTemplate": function (e) {
        const file = e.target.files[0];
        this.trigger("upload:template", file, e.target.form);
      },
      "click #siteMapCssUploadButton": function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#siteMapCss", this.$el).trigger("click");
      },
      "click #siteMapTemplateUploadButton": function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#siteMapTemplate", this.$el).trigger("click");
      },
      "click .add-privileged-area": function (e) {
        e.preventDefault();
        e.stopPropagation();
        const privilegedAreaRoleId = $(e.target).closest("a").data("privileged-area-role-id");
        this.trigger("add:privilegedArea", +privilegedAreaRoleId);
      },
      "click .remove-privileged-area": function (e) {
        e.preventDefault();
        e.stopPropagation();
        const privilegedAreaRoleId = $(e.target).closest("a").data("privileged-area-role-id");
        this.trigger("remove:privilegedArea", +privilegedAreaRoleId);
      },
      "click .add-touchpoint": function (e) {
        e.preventDefault();
        e.stopPropagation();
        const touchPointId = $(e.target).closest("a").data("touch-point-id");
        this.trigger("add:touchPoint", +touchPointId);
      },
      "click .remove-touchpoint": function (e) {
        e.preventDefault();
        e.stopPropagation();
        const touchPointId = $(e.target).closest("a").data("touch-point-id");
        this.trigger("remove:touchPoint", +touchPointId);
      },
    },
    triggers: {
      "click #deleteSiteMap": "remove:siteMap",
      "click #siteMapCssRemove": "remove:css",
    },
    modelEvents: {
      "change:cssFileName": "render",
      "change:privilegedAreaRoleIds": "render",
      "change:templateFileName": "render",
      "change:touchPointIds": "render",
    },
    regions: {
      uploads: "#siteMapUploads",
    },
    textboxes: {
      "#siteMapName": {
        enableSelector: ["#siteMapName", "#siteMapNameLabel"],
        modelAttribute: "name",
        placeholder: "admin.siteMaps.name",
      },
    },
    templateError: function (errorMessage) {
      this.$el
        .find("#siteMapTemplateError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    touchPointsError: function (errorMessage) {
      this.$el
        .find("#siteMapTouchPointsError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return SiteMapView;
});
